<div class="layout-shell" [class.sidebar-collapsed]="isCollapsed">
  <aside class="app-sidenav" role="navigation" aria-label="Primary">
    <div class="top-section" (click)="goHome()" role="button" tabindex="0">
      <span class="logo-pair" aria-hidden="true">
        <img class="logo-full" src="assets/icons/white-logo.svg" alt="AstraZeneca home" />
        <img class="logo-compact" src="assets/icons/az-only-logo.svg" alt="AstraZeneca home" />
      </span>
      <span class="product-tagline" aria-label="Binding Corporate Rules">
        <span class="tagline-full" [class.tagline-visible]="!isCollapsed">
          Binding Corporate Rules
        </span>
        <span class="tagline-short" [class.tagline-visible]="isCollapsed">BCR</span>
      </span>
      <hr />
    </div>
    <nav class="nav-list" aria-label="Main menu">
      @for (item of navItems; track trackByNav($index, item)) {
        <a
          class="nav-item"
          [routerLink]="item.route"
          [routerLinkActive]="item.route ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: true }"
          #rla="routerLinkActive"
          [attr.aria-current]="rla.isActive ? 'page' : null"
          [attr.aria-label]="isCollapsed ? item.label : null"
          [appSidebarFlyout]="item.label"
          [collapsed]="isCollapsed"
        >
          <span
            class="nav-icon"
            [ngClass]="[item.iconSet, isCollapsed ? 'icon-collapsed' : 'icon-expanded']"
            aria-hidden="true"
            >{{ item.icon }}</span
          >
          <span
            class="nav-label"
            [class.nav-label--visible]="!isCollapsed"
            [attr.aria-hidden]="isCollapsed ? 'true' : null"
            >{{ item.label }}</span
          >
        </a>
      }
      <a
        class="nav-item support-link"
        [routerLink]="'/support'"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.aria-label]="isCollapsed ? 'Support' : null"
        appSidebarFlyout="Support"
        [collapsed]="isCollapsed"
      >
        <span class="nav-icon material-symbols-outlined" aria-hidden="true">help</span>
        <span
          class="nav-label"
          [class.nav-label--visible]="!isCollapsed"
          [attr.aria-hidden]="isCollapsed ? 'true' : null"
          >Support</span
        >
      </a>
    </nav>
    <div class="bottom-section">
      <button
        type="button"
        class="collapse-btn"
        (click)="toggle()"
        [attr.aria-expanded]="!isCollapsed"
        [attr.title]="isCollapsed ? 'Expand' : 'Collapse'"
        [attr.aria-label]="isCollapsed ? 'Expand' : 'Collapse'"
        [appSidebarFlyout]="isCollapsed ? 'Expand' : ''"
        [collapsed]="isCollapsed"
      >
        <span class="material-symbols-outlined" aria-hidden="true">{{
          isCollapsed ? 'left_panel_open' : 'left_panel_close'
        }}</span>
        <span class="collapse-label" [class.collapse-label--visible]="!isCollapsed">Collapse</span>
      </button>
      <div class="logo-wrapper">
        <span class="logo-pair" aria-hidden="true">
          <img class="logo-full" src="assets/icons/white-logo.svg" alt="AstraZeneca logo" />
          <img class="logo-compact" src="assets/icons/az-only-logo.svg" alt="AstraZeneca logo" />
        </span>
      </div>
    </div>
  </aside>
  <main class="content" [class.content--compact]="isHome" role="main">
    <ng-content />
  </main>
</div>
